import { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';

/** Design `.lnk`: 13px semibold muted-2 text link, ink + underline on hover. */
export const TEXT_LINK =
  'inline-flex min-h-[32px] items-center gap-1 text-[13px] font-semibold text-muted-2 no-underline hover:text-ink hover:underline hover:underline-offset-[3px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent rounded-[4px]';

/** Design `.lnkb`: the same text as a padded button with a faint navy hover fill. */
export const TEXT_LINK_BUTTON =
  'inline-flex min-h-[32px] items-center gap-1 rounded-[8px] border-0 bg-transparent px-2 text-[13px] font-semibold text-muted-2 hover:bg-navy/[.07] hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent';

type LinkProps = { to: string; children: ReactNode; className?: string } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>;

/** Router link styled as the design `.lnk`. External URLs: use `<a className={TEXT_LINK}>`. */
export default function TextLink({ to, children, className = '', ...rest }: LinkProps) {
  return <Link to={to} {...rest} className={`${TEXT_LINK} ${className}`}>{children}</Link>;
}

/** Button styled as the design `.lnkb` (Dismiss, Undo, inline actions). */
export function TextLinkButton({ children, className = '', type = 'button', ...rest }: ButtonHTMLAttributes<HTMLButtonElement> & { children: ReactNode }) {
  return <button type={type} {...rest} className={`${TEXT_LINK_BUTTON} ${className}`}>{children}</button>;
}
